import {
  FETCH_CREDIT_LIMIT_REQUEST,
  FETCH_CREDIT_LIMIT_SUCCESS,
  FETCH_CREDIT_LIMIT_FAILURE,
  FETCH_CREDIT_LIMIT_RESET
} from '../constants';

const initialState = {
  creditLimitRequest: false,
  creditLimitData: {},
  creditLimitStatus: false
};

interface stateType {
  creditLimitRequest: boolean;
  creditLimitData: Object;
  creditLimitStatus: boolean;
}

interface actionType {
  type: string;
  payload?: {
    data?: Object;
    error?: string;
  };
}

export const creditLimitReducer = (state = initialState, action: actionType): stateType => {
  switch (action.type) {
    case FETCH_CREDIT_LIMIT_REQUEST:
      return {
        ...state,
        creditLimitRequest: true,
        creditLimitData: {},
        creditLimitStatus: false
      };
    case FETCH_CREDIT_LIMIT_SUCCESS:
      return {
        ...state,
        creditLimitRequest: false,
        creditLimitData: action.payload?.data || {},
        creditLimitStatus: true
      };
    case FETCH_CREDIT_LIMIT_FAILURE:
      return {
        ...state,
        creditLimitRequest: false,
        creditLimitData: {},
        creditLimitStatus: false
      };
    case FETCH_CREDIT_LIMIT_RESET:
      return initialState;
    default:
      return state;
  }
};
